module.exports = __webpack_public_path__ + "img/shape-book-no-cover.1eb1710b.svg";